import _toConsumableArray from "/home/runner/work/AluPriser.dk/AluPriser.dk/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/home/runner/work/AluPriser.dk/AluPriser.dk/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/home/runner/work/AluPriser.dk/AluPriser.dk/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["headers", "query"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

export var cloneRequest = function cloneRequest(_ref) {
  var headers = _ref.headers,
      query = _ref.query,
      rest = _objectWithoutProperties(_ref, _excluded);

  return _objectSpread(_objectSpread({}, rest), {}, {
    headers: _objectSpread({}, headers),
    query: query ? cloneQuery(query) : undefined
  });
};
export var cloneQuery = function cloneQuery(query) {
  return Object.keys(query).reduce(function (carry, paramName) {
    var param = query[paramName];
    return _objectSpread(_objectSpread({}, carry), {}, _defineProperty({}, paramName, Array.isArray(param) ? _toConsumableArray(param) : param));
  }, {});
};